"use strict";

import jQuery from 'jquery';

/**
 * @classdesc
 * FeatureInfo-Panel
 *
 * @class
 * @extends gc.gis.widget.GCPanel
 * @memberof gc.gis.module.GCFeatureInfo
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {gc.gis.module.GCFeatureInfo} options.module Modul-Instanz
 * @param {gc.gis.module.GCFeatureInfo.ResultList} options.resultList Container für die Ergebnisliste
 */
gc.gis.module.GCFeatureInfo.Panel = function(options)
{
    gc.gis.assert.isSet(options);
    gc.gis.assert.isInstance(options.module, gc.gis.module.GCFeatureInfo);
    gc.gis.assert.isInstance(options.resultList, gc.gis.widget.GCWidget);

    /**
     * @type {gc.gis.module.GCFeatureInfo}
     * @private
     */
    this._module = options.module;
    /**
     * @type {gc.gis.module.GCFeatureInfo.ResultList}
     * @private
     */
    this._result_list_sidebar = options.resultList;
    /**
     * @type {number}
     * @private
     */
    this._layerSelectionMode = gc.gis.module.GCFeatureInfoConstants.QUERY_LAYER_VISIBLE;
    /**
     * @type {number}
     * @private
     */
    this._geometryType = gc.gis.module.GCFeatureInfoConstants.IDENTIFY_POINT;
    /**
     * @type {gc.gis.layer.GCLayer}
     * @private
     */
    this._selectedLayer = undefined; // Layer in Einzelauswahl
    /**
     * @type {gc.gis.widget.GCItem}
     * @private
     */
    this._btnDrawArea = undefined;
    /**
     * @type {string}
     * @private
     */
    this._tooltipDrawArea = 'Objekt-Informationen anhand der Zeichenfläche';
    /**
     * @type {string}
     * @private
     */
    this._tooltipEmptyDrawArea = 'Objekt-Informationen anhand der Zeichenfläche - die Zeichenfläche ist leer';

    var options_widget = {
        className: 'gc-featureinfo',
        //target: '#gc_featureinfo',
        toolbar: this._initToolbar()
    };
    gc.gis.widget.GCPanel.call( this, options_widget );

    this.element = this._render();
    this._initContent();
    this._initEvents();
};
gc.gis.module.GCFeatureInfo.Panel.prototype = Object.create( gc.gis.widget.GCPanel.prototype );


/**
 * Liefert den aktuell eingestellten Layer-Auswahlmodus.
 *
 * @public
 * @method
 */
gc.gis.module.GCFeatureInfo.Panel.prototype.getLayerSelectionMode = function()
{
    return this._layerSelectionMode;
};

/**
 * Liefert den aktuell eingestellten Abfragegeometrietyp.
 *
 * @public
 * @method
 */
gc.gis.module.GCFeatureInfo.Panel.prototype.getGeometryType = function()
{
    return this._geometryType;
};

/**
 * Liefert den aktuell eingestellten Layer für die Einzellayer-Abfrage oder <code>null</code> fals kein Layer ausgewählt
 * wurde.
 *
 * @public
 * @method
 * @return gc.gis.layer.GCLayer|undefined
 */
gc.gis.module.GCFeatureInfo.Panel.prototype.getSelectedLayer = function()
{
    return this._selectedLayer;
};

/**
 * Initialisiert den Panel-Inhalt.
 *
 * @protected
 * @method
 */
gc.gis.module.GCFeatureInfo.Panel.prototype._initContent = function()
{
    var self = this;
    var form_config = {
        className: 'form-featureinfo',
        controls: [
            {
                label: 'Welche Ebenen sollen abgefragt werden?',
                name: 'featureinfo_layer',
                type: 'layer-selector',
                map: this._module._map,
                mode: gc.gis.widget.GCLayerSelectorMode.ALL
                    | gc.gis.widget.GCLayerSelectorMode.SELECTED
                    | gc.gis.widget.GCLayerSelectorMode.VISIBLE
                    | gc.gis.widget.GCLayerSelectorMode.SINGLE,
                sort: gc.gis.widget.GCLayerSelectorSort.ASCENDING,
                selectLayerFilter: function(layer)
                {
                    return !(layer instanceof gc.gis.layer.GCGroupLayer)
                        && layer.isReallyVisible()
                        && layer.isQueryable();
                },
                change: function (evt, ctrl)
                {
                    self._selectedLayer = undefined;

                    var old_mode = self._layerSelectionMode;
                    switch (ctrl.getMode())
                    {
                        case gc.gis.widget.GCLayerSelectorMode.SELECTED:
                            self._layerSelectionMode = gc.gis.module.GCFeatureInfoConstants.QUERY_LAYER_SELECTED;
                            break;
                        case gc.gis.widget.GCLayerSelectorMode.ALL:
                            self._layerSelectionMode = gc.gis.module.GCFeatureInfoConstants.QUERY_LAYER_ALL;
                            break;
                        case gc.gis.widget.GCLayerSelectorMode.SINGLE:
                            self._layerSelectionMode = gc.gis.module.GCFeatureInfoConstants.QUERY_LAYER_SINGLE;
                            self._selectedLayer = ctrl.getSingleLayerSelection();
                            break;
                        default:
                            self._layerSelectionMode = gc.gis.module.GCFeatureInfoConstants.QUERY_LAYER_VISIBLE;
                            break;
                    }

                    if (old_mode !== self._layerSelectionMode)
                    {
                        self._fireEvent(gc.gis.module.GCFeatureInfoEvent.LAYER_MODE_CHANGED, {
                            old_mode: old_mode,
                            new_mode: self._layerSelectionMode
                        });
                    }
                }
            },
            {
                label: 'Ergebnisse zurücksetzen',
                name: 'featureinfo_reset',
                type: 'button',
                click: function (evt) {
                    self._fireEvent(gc.gis.module.GCFeatureInfoEvent.RESULT_RESET, {});
                }
            }
        ]
    };

    this.form = gc.gis.util.GCFormRenderer.renderForm(form_config);
    this.element_content.append(this.form.getElement());

    // Ergebnisliste anzeigen
    this.element_content.append(this._result_list_sidebar.getElement());
};

/**
 * Initialisiert die Toolbar.
 *
 * @method
 * @return {Object}
 * @protected
 */
gc.gis.module.GCFeatureInfo.Panel.prototype._initToolbar = function() {
    var self = this;
    var items = [
        new gc.gis.widget.GCToggleItem({
            label: 'Punkt',
            tooltip: 'Objekt-Informationen zu einem Punkt',
            className: 'btn btn-default',
            icon: 'ms ms-points',
            active: this._geometryType === gc.gis.module.GCFeatureInfoConstants.IDENTIFY_POINT,
            click: function (evt) {
                self._onGeometryButtonClicked(evt, jQuery(this), gc.gis.module.GCFeatureInfoConstants.IDENTIFY_POINT);
            }
        }),
        new gc.gis.widget.GCToggleItem({
            label: 'Rechteck',
            tooltip: 'Objekt-Informationen zu einem Rechteck',
            className: 'btn btn-default',
            icon: 'ms ms-vector',
            active: this._geometryType === gc.gis.module.GCFeatureInfoConstants.IDENTIFY_BOX,
            click: function (evt) {
                self._onGeometryButtonClicked(evt, jQuery(this), gc.gis.module.GCFeatureInfoConstants.IDENTIFY_BOX);
            }
        }),
        new gc.gis.widget.GCToggleItem({
            label: 'Polygon',
            tooltip: 'Objekt-Informationen zu einem Polygon',
            className: 'btn btn-default',
            icon: 'ms ms-polygon',
            active: this._geometryType === gc.gis.module.GCFeatureInfoConstants.IDENTIFY_POLYGON,
            click: function (evt) {
                self._onGeometryButtonClicked(evt, jQuery(this), gc.gis.module.GCFeatureInfoConstants.IDENTIFY_POLYGON);
            }
        })
    ];

    // TODO Funktion fertigstellen
    /*
    this._btnDrawArea = new gc.gis.widget.GCItem({
        label:  'Zeichenfläche',
        tooltip: this._tooltipEmptyDrawArea,
        className: 'btn btn-default',
        icon: 'ms ms-draw-polygon',
        click: function(evt) {
            self._onQueryDrawingAreaClicked(evt);
        }
    });
    this._btnDrawArea.getElement().hide();  // Button wird in Abhängigkeit der Verfügbarkeit des Zeichnenmoduls eingeblendet
    this._btnDrawArea.setEnabled(false);
    items.push(this._btnDrawArea);
    */

    return {items: items};
};

/**
 * Initialisiert die Events.
 *
 * @method
 * @return {Object}
 * @protected
 */
gc.gis.module.GCFeatureInfo.Panel.prototype._initEvents = function()
{
    var self = this;

    // Abhängiges Modul überwachen und Button Zeichenfläche ein-/ausschalten

    /*
    gc.gis.iface.on(gc.gis.GCApplicationEvent.MODULE_LOADED, this, function (evt) {
        if (evt.instance instanceof gc.gis.module.GCDigitize) {
            self._btnDrawArea.getElement().show();

            var trackingLayer = evt.instance.getLayer();
            var updateButtonFunction = function() {
                self._btnDrawArea.setEnabled(trackingLayer.numFeatures() > 0);
                if (trackingLayer.numFeatures() > 0) {
                    self._btnDrawArea.setTooltip(this._tooltipDrawArea);
                }
                else {
                    self._btnDrawArea.setTooltip(this._tooltipEmptyDrawArea);
                }
            };

            trackingLayer.on(gc.gis.layer.GCVectorLayerEvent.FEATURE_ADDED, this, updateButtonFunction);
            trackingLayer.on(gc.gis.layer.GCVectorLayerEvent.FEATURE_REMOVED, this, updateButtonFunction);
            trackingLayer.on(gc.gis.layer.GCVectorLayerEvent.LAYER_CLEARED, this, updateButtonFunction);
        }
    });
    */
};

/**
 * Ereignisbehandlungsroutine die aufgerufen wird, wenn ein Nutzer einen Button zum Ändern der Abfragegeometrie
 * angeklickt hat.
 *
 * @method
 * @param {jQuery.Event} evt
 * @param {jQuery} button
 * @param {int} type
 * @private
 */
gc.gis.module.GCFeatureInfo.Panel.prototype._onGeometryButtonClicked = function(evt, button, type)
{
    evt.preventDefault();   // verhindern, dass die weitere Verarbeitung abgearbeitet wird, ansonsten wird der aktive Button beim erneuten Klick getoggelt

	var i,
		buttons = this.element_toolbar.getItems();

	for (i=0; i<buttons.length; i++)
	{
		buttons[i].setActive(buttons[i].getElementControl().get(0) === button.get(0));
	}

    // ggf. Event auslösen
    if (type !== this._geometryType)
    {
        var old_type = this._geometryType;
        this._geometryType = type;

        this._fireEvent(gc.gis.module.GCFeatureInfoEvent.GEOMETRY_TYPE_CHANGED, {
            old_type: old_type,
            new_type: this._geometryType
        });
    }
};

/**
 * Ereignisbehandlungsroutine die aufgerufen wird, wenn ein Nutzer einen Button zum Ändern der Abfragegeometrie
 * angeklickt hat.
 *
 * @method
 * @param {jQuery.Event} evt
 * @private
 */
gc.gis.module.GCFeatureInfo.Panel.prototype._onQueryDrawingAreaClicked = function(evt)
{
    if (this._btnDrawArea.isEnabled())
    {
        this._fireEvent(gc.gis.module.GCFeatureInfoEvent.QUERY_DRAWINGAREA, {});
    }
};
